import { postBiz, json, rows } from '../core/coreapi';

export const findDeterminantBudgets = async (f:any) =>
  rows(await postBiz({
    s: 'determinantbudget', 
    a: 'find',
    pci:f.planningcycleid ?? null,
    sti:f.stateid ?? null,
    sts:f.status ?? 1,
    pos:f.page ?? 0,
    plm:f.pagesize ?? 50,
  }));

export const createFromReview = async (p:any) =>
  json(await postBiz({
    s: 'determinantbudget', 
    a: 'create',
    eri:p.executivereviewid,
    nam:p.name,
    dsc:p.description ?? '',
  }));

export const adjustBudget = async (p:any) =>
  json(await postBiz({
    s: 'determinantbudget', 
    a: 'adjust',
    rid:p.rid,
    amt:Number(p.adjustmentamount || 0),
    rsn:p.adjustmentreason || '',
    rsv:Number(p.reserveamount || 0),
  }));

export const acceptBudget = async (rid:number, notes='') =>
  json(await postBiz({s: 'determinantbudget', a:'accept',rid,nts:notes}));

export const returnBudget = async (rid:number, reason='') =>
  json(await postBiz({s: 'determinantbudget', a:'return',rid,rsn:reason}));

export const releaseBudget = async (rid:number, notes='') =>
  json(await postBiz({s: 'determinantbudget', a:'release',rid,nts:notes}));

export const validateBudget = async (rid:number) =>
  json(await postBiz({s: 'determinantbudget', a:'validate',rid}));

export const loadBudgetReport = async (rid:number) =>
  json(await postBiz({s: 'determinantbudget', a:'report',rid}));
